// Looking at the video from the page: a small copy of the frame on screen (for the look thumbnails and the histogram), and measurements of frames spread through the video.
import { combineStats, statsFromRGBA } from "./grade";

// A copy of the video's current frame, `width` pixels wide, as ImageData; null while the video has no picture yet.
export function grabFrame(video, width = 160) {
  if (!video.videoWidth || video.readyState < 2) return null;
  const w = width;
  const h = Math.max(2, Math.round((width * video.videoHeight) / video.videoWidth));
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(video, 0, 0, w, h);
  try { return ctx.getImageData(0, 0, w, h); } catch { return null; }
}

const seekTo = (video, t) => new Promise((resolve) => {
  const done = () => { video.removeEventListener("seeked", done); resolve(); };
  video.addEventListener("seeked", done);
  video.currentTime = t;
  setTimeout(done, 1500);
});

// The measurements (see grade.statsFromRGBA) of a few frames spread through the video, combined. The video is put back where it was.
export async function sampleStats(video, frames = 5) {
  const length = isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
  const times = length > 1 ? Array.from({ length: frames }, (_, i) => length * (0.1 + (0.8 * i) / Math.max(1, frames - 1))) : [video.currentTime];
  const was = video.currentTime;
  const wasPaused = video.paused;
  const found = [];
  try {
    video.pause();
    for (const t of times) {
      await seekTo(video, t);
      const frame = grabFrame(video, 192);
      if (frame) found.push(statsFromRGBA(frame.data));
    }
  } finally {
    await seekTo(video, was);
    if (!wasPaused) video.play().catch(() => {});
  }
  return found.length ? combineStats(found) : null;
}
